import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CreateAccountComponent } from './create-account.component';
import { CreateAccountResolve } from './create-account.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'create-account/:inviteId',
        component: CreateAccountComponent,
        resolve: {
          invite: CreateAccountResolve
        }
      },
      {
        path: 'create-account/:inviteId/:advertiserId',
        component: CreateAccountComponent,
        resolve: {
          invite: CreateAccountResolve
        }
      },
      {
        path: 'create-account',
        component: CreateAccountComponent,
      },
    ])
  ],
  exports: [RouterModule]
})
export class CreateAccountRoutingModule {}
